import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { colors } from '@opendoor/bricks/theme/eero';

import ImgixImg from '../shared/ImgixImg';
import useQueryParams from '../../helpers/queryParams';

const PressItem = styled.div`
  width: 200px;
  text-align: center;
  margin: 0 30px;

  @media (max-width: 1100px) {
    width: 100px;
    margin: 0 15px;
  }

  @media (max-width: 767px) {
    margin: 0;
    width: 200px;
    text-align: left;
    margin-right: 30px;
  }
`;

const Section = styled.section`
  position: relative;
  display: flex;
  padding: 50px 50px 0 50px;
  justify-content: space-between;
  background-color: ${colors.neutrals0};

  @media (max-width: 1100px) {
    padding: 30px 30px 0 30px;
  }

  @media (max-width: 767px) {
    overflow-x: scroll;
    padding: 20px 20px 0 20px;
    margin-right: 20px;
    & {
      .press-1 {
        order: 2;
      }
      .press-2 {
        order: 3;
      }
      .press-3 {
        order: 1;
      }
      .press-4 {
        order: 4;
      }
      .press-5 {
        order: 5;
      }
      .press-6 {
        order: 6;
      }
    }
  }
`;

const Quote = styled.blockquote`
  margin: 0 0 20px;
  padding: 0;
  font-size: 14px;
  color: ${colors.neutrals90};
  line-height: 1.2;
  margin-top: 20px;
  border: 0;

  @media (max-width: 1100px) {
    width: 100px;
    font-size: 13px;
    margin: 10px 0 0 0;
  }

  @media (max-width: 767px) {
    width: 140px;
    font-size: 11px;
    margin: 10px 0 0 0;
  }
`;

const imgCss = css`
  @media (max-width: 1100px) {
    height: 16px;
  }

  @media (max-width: 767px) {
    height: 16px;
  }
`;

const Stars = styled.img`
  margin-top: 15px;

  @media (max-width: 1100px) {
    height: 16px;
  }

  @media (max-width: 767px) {
    height: 16px;
  }
`;

const Rating = styled.p`
  font-size: 12px; // .text-small
  color: ${colors.neutrals90};
`;

const Press = () => {
  let rating;
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    rating = require('../../../data/rating.json')['average_rating'];
  } catch (err) {
    // something is wrong with fetch rating, default 4.5
    rating = '4.5';
  }

  const { social_proof } = useQueryParams();
  return (
    <Section>
      <PressItem className="press-1">
        <ImgixImg
          css={imgCss}
          src="85d5b06bee184e76bb9aeb5cfc8aa240.png"
          alt="The New York Times"
          height={30}
        />
        <Quote cite="https://www.nytimes.com/2017/05/24/technology/opendoor-start-up-home-sales.html">
          “Moving as simple as the click of a button”
        </Quote>
      </PressItem>
      <PressItem className="press-2">
        <ImgixImg
          css={imgCss}
          src="e88686bdd6aa4706ad0d7e98b00ec677.png"
          alt="Forbes"
          height={30}
        />
        <Quote cite="https://www.forbes.com/sites/amyfeldman/2016/11/30/home-shopping-networkers-opendoor-is-upending-the-way-americans-buy-and-sell-homes">
          “Changing the way Americans buy and sell”
        </Quote>
      </PressItem>
      {social_proof !== 'show_social_proof' && (
        <PressItem
          className="press-3"
          css={css`
            // this is required, even though it isn't applied on desktop
            // it seems to trick emotion into thinking that this is a different class
            // (or my nth-of-type is wrong)
            order: 0;
          `}
        >
          <ImgixImg
            css={imgCss}
            src="320adb9c154840c99dad5e0772fc5d86.jpg"
            alt="Reviews.io"
            height={30}
          />
          <Stars
            src="https://imgdrop.imgix.net/150b8d8c42c7471a9281fc1297150827.svg"
            alt="4.5/5 stars rating"
            height={24}
          />
          <Rating>{rating}/5</Rating>
        </PressItem>
      )}
      <PressItem className="press-4">
        <ImgixImg
          css={imgCss}
          src="387e28f0c9774fdeabb4ecb65ca70173.png"
          alt="Fortune"
          height={30}
        />
        <Quote cite="http://fortune.com/2015/06/02/future-house-shopping/">
          “Fair offer price within minutes”
        </Quote>
      </PressItem>
      <PressItem className="press-5">
        <ImgixImg css={imgCss} src="8471aa4d2b7746d1917afd262c89545f.png" alt="WSJ" height={30} />
        <Quote cite="https://www.wsj.com/articles/who-needs-a-down-payment-trade-in-your-old-home-instead-1527023558">
          “Take the hassle out of selling”
        </Quote>
      </PressItem>
      <PressItem className="press-6">
        <ImgixImg src="7b2a0c8f154e44c9b2c99e23343ac2de.jpg" alt="BBB" height={35} />
      </PressItem>
    </Section>
  );
};

export default Press;
